import { render, staticRenderFns } from "./VaultManager.vue?vue&type=template&id=0a1cd00e&scoped=true&"
import script from "./VaultManager.vue?vue&type=script&lang=js&"
export * from "./VaultManager.vue?vue&type=script&lang=js&"
import style0 from "./VaultManager.vue?vue&type=style&index=0&id=0a1cd00e&scoped=true&lang=css&"
import style1 from "./VaultManager.vue?vue&type=style&index=1&id=0a1cd00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1cd00e",
  null
  
)

export default component.exports